<script>
  import { effectif } from "../store/store.js";
  import { onMount } from "svelte";
  let searchTerm;
  let result;

  const leFiltre = async () => {
    const x = $effectif.filter(
      (d) =>
        d.EM_POSTE.search(searchTerm) != -1 || d.EM_NOM.search(searchTerm) != -1
    );
    console.dir(x);
    return x;
  };

  const chercher = () => {
    result = leFiltre();
  };
  result = leFiltre();
</script>

<h5>sdgsdgfsdgsdgg</h5>
{#await result}
  wait
{:then element}
  <div class="row">
    <nav class="navbar bg-light">
      <div class="container-fluid">
        <form class="d-flex" role="search">
          <input
            bind:value={searchTerm}
            class="form-control me-2"
            type="search"
            placeholder="nom/poste"
            aria-label="Search"
          />
          <button
            on:click={() => chercher()}
            class="btn btn-outline-success"
            type="submit">Search</button
          >
        </form>
      </div>
    </nav>
  </div>

  <h4>resultat recherche</h4>
  <ul>
    {#each element as item}
      <li>{item.EM_NOM} : {item.EM_POSTE}</li>
    {/each}
  </ul>
{/await}
